import {Module, Action, getModule} from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import {getList} from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import {Difficulties} from '@/models/difficulties';
import {Filter} from "@/types/filter/filter";
import filterModel from "@/store/difficulties/filterModel";
import DifficultiesFilter from "@/store/difficulties/filterEntity";

export const MODULE_NAME = Difficulties.moduleName;

@Module({dynamic: true, store, name: MODULE_NAME, namespaced: true})
class DifficultiesModule extends PageBaseModule {
    filter: Filter;

    constructor(module: DifficultiesModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(Difficulties.listTitle);
        page.setTitleAdd(Difficulties.createTitle);
        page.values.actionPagination = 'difficulties/updatePage';
        page.values.actionPageAmountItems = 'difficulties/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Difficulties.moduleName}_edit`;
        this.pageSettings.routeParam = `${Difficulties.moduleName}Id`;

        const filter = new filterModel();
        this.filter = getModule(DifficultiesFilter);
        this.filter.setFilterName('difficultiesFilter');
        this.filter.setTemplateClassName('template-lg directory-filters');
        this.filter.setFilterModel(filter.filterModel);
        this.filter.setFilterHandlers(filter.filterHandlers);
    }

    @Action({rawError: true})
    async init() {
        await this.getList();
    }

    @Action({rawError: true})
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(
                Difficulties.apiPrefix,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            await this.context.dispatch('setList', result.table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(DifficultiesModule);
